import React, { useEffect, useRef, useState } from "react";
import { useMobileView } from "../../contexts/MobileViewContext";
import cardLoader from "../../hooks/cardLoader";
import "../../components/CSS/Home/AboutSection.css";

// import achievement_img1 from "../../assets/images/achievements-img1.png";
// import achievement_img2 from "../../assets/images/achievements-img2.png";
import gb from "../../assets/images/forbes1.png";
import achivement_bg from "../../assets/images/vmg-background.jpg";
import vision_icon from "../../assets/icons/vmg-icon1.png";
import mission_icon from "../../assets/icons/vmg-icon2.png";
import goal_icon from "../../assets/icons/vmg-icon3.png";

import IconCard from "./IconCard";
import contentData from "../../data/WhyChooseUsPageData";
import "../../components/CSS/Home/WhyChooseUsSection.css";

const IntTerminalWaiverText = () => {
  return (
    <div style={{ marginTop: "40px" }}>
      <p className="font-secondary">
        INT Terminal (INT Terminal Travel Group) is a travel solutions provider
        that acts as an "airline without an aircraft," connecting clients to
        flights via partnerships with 25+ airlines and over 1,000 suppliers
        globally. We offer customized aviation and travel services for
        individuals, corporate clients, and travel agents. With decades of
        industry experience, we emphasize seamless service, creative solutions,
        and strong client relationships.
      </p>
      <a
        href="https://intterminal.com/waiver"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <button
          style={{
            background: "#000000",
            border: "none",
            color: "white",
            cursor: "pointer",
            padding: "12px 24px",
            fontSize: "16px",
            borderRadius: "5px",
            marginTop: "20px",
            transition: "background 0.3s ease",
          }}
          className="font-secondary"
          onMouseOver={(e) => (e.target.style.background = "#36454F")}
          onMouseOut={(e) => (e.target.style.background = "#000000")}
        >
          Read More
        </button>
      </a>
      <br />
      <p className="font-secondary" style={{ marginTop: "40px" }}>
        Find us on:
      </p>
      <div style={{ display: "flex", gap: "15px", marginTop: "15px" }}>
        <a
          href="https://www.instagram.com/intterminal/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: "24px", color: "#E4405F" }}
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/IntTerminalLLC/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: "24px", color: "#1877F2" }}
        >
          <i className="fab fa-facebook"></i>
        </a>
        <a
          href="https://www.linkedin.com/company/int-terminal/mycompany/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: "24px", color: "#0A66C2" }}
        >
          <i className="fab fa-linkedin"></i>
        </a>
        <a
          href="https://x.com/int_terminal"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: "24px", color: "#1DA1F2" }}
        >
          <i className="fab fa-twitter"></i>
        </a>
      </div>
    </div>
  );
};

const AboutUsContent = () => {
  const isMobileView = useMobileView();
  const iconCardsRef = useRef([]);

  useEffect(() => {
    const section = document.getElementById("our-story");
    const blockSection = document.getElementById("our-story-content");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          blockSection.classList.add("animate-block");
        }
      },
      { threshold: 0.5 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  useEffect(() => {
    const section = document.getElementById("our-missionVision");
    const blockSection = document.getElementById("our-missionVision-content");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          blockSection.classList.add("animate-vmCard");
        }
      },
      { threshold: 0.5 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  useEffect(() => {
    const section = document.getElementById("our-achievements");
    const blockSection = document.getElementById("our-achievements-content");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          blockSection.classList.add("animate-block");
        }
      },
      { threshold: 0.5 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  cardLoader(iconCardsRef, "visible", 200, { threshold: 0.5 });

  return (
    <section
      id="aboutus-content-section"
      className={`aboutus-content-section d-flex ${
        isMobileView ? "mobile-view" : ""
      }`}
    >
      <div className="aboutus-section-content page-section">
        <section id="top-cards" className="top-cards">
          <div id="top-cards-content" className="top-cards-content row d-flex">
            <div className="tc-head">
              <h3 className="font-primary" style={{ textAlign: "left" }}>
                Why Choose Us
              </h3>
              <hr />
            </div>

            {contentData.map((content, index) => (
              <div
                className="col-md-4 col-sm-6 col-12 icon-card-col"
                key={index}
              >
                <IconCard
                  className={`icon-card2`}
                  content={content}
                  ref={(el) => (iconCardsRef.current[index] = el)}
                  style={{ "--animation-order": index }}
                />
              </div>
            ))}
          </div>
        </section>

        <section
          id="our-story"
          className="our-story why-choose-item"
          style={{ marginTop: "80px" }}
        >
          <div
            id="our-story-content"
            className="our-story-content col-12 d-flex"
            style={{ flexWrap: "wrap" }}
          >
            <div className="col-lg-8 txt-col">
              <div>
                <h3
                  className="font-primary"
                  style={{ textAlign: "left", marginBottom: "10px" }}
                >
                  Our Story
                </h3>
                <hr />
                <h3
                  className="font-secondary"
                  style={{ fontSize: "25px", marginTop: "40px" }}
                >
                  At the heart of our mindfulness vacations is Dr. Gamini
                  Hewawasam
                </h3>
                <p className="font-secondary">
                  Dr. GB Hewawasam, a Forbes Coach Council member and a leading
                  practitioner of the original form of mindfulness, carries over
                  12 years of experience in the travel industry in the USA, thus
                  making him an ideal expert regarding the benefits of
                  Mindfulness Tourism. Through his extensive research and
                  experience, Dr. Hewawasam has recognized a gap between
                  traditional mindfulness teachings preserved in Sri Lanka and
                  the often diluted Western practices.{" "}
                </p>
                <br />
                <p className="font-secondary">
                  Dedicated to bridging this gap, Dr. Hewawasam invites seekers
                  like you to experience mindfulness in its most authentic form.
                  Our meticulously crafted itineraries are designed to satisfy
                  your personal goals, allowing you to truly immerse yourself in
                  the essence of mindfulness as practiced for centuries in Sri
                  Lanka.
                </p>
                <br />
                <p className="font-secondary">
                  Every aspect of your journey is tailored to resonate with your
                  unique style and perspective, providing a deep and meaningful
                  experience that goes beyond conventional practices. Discover
                  the true depth and serenity of mindfulness, guided by Dr.
                  Hewawasam's expertise, and enrich your leadership journey with
                  us.
                </p>
              </div>
            </div>
            <div className="col-lg-4" style={{ textAlign: "right" }}>
              <img
                src={gb}
                alt="doctor Gamini Hewawasm's image"
                className="story-img"
                loading="lazy"
              />
            </div>
          </div>
        </section>

        <section
          id="int-terminal-waiver"
          className="int-terminal-waiver why-choose-item"
          style={{ marginTop: "80px" }}
        >
          <div
            id="int-terminal-waiver-content"
            className="int-terminal-waiver-content"
          >
            <div className="txt-col">
              <div>
                <h3
                  className="font-primary"
                  style={{ textAlign: "left", marginBottom: "10px" }}
                >
                  INT Terminal Waiver
                </h3>
                <hr />
                <IntTerminalWaiverText />
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={require("../../assets/images/waiver.png")}
                alt="INT Terminal Waiver"
                className="story-img"
                loading="lazy"
              />
            </div>
          </div>
        </section>

        {/* <section id='our-achievements' className='our-achievements why-choose-item'>
          <div className="our-achievements-overlayer"></div>
          <img src={achivement_bg} className='our-achievements-bg' alt="mindfulness section background image" loading='lazy'/>
          <div id='our-achievements-content' className='our-achievements-content'>
            <div>
            <h3 className="font-primary">Our Achievements</h3><hr style={{margin: isMobileView?'-30px 0 50px 0':'-50px 0 50px 0'}} />
            <div className="row d-flex">
              <div className="col-lg-6">
                <div className="achivement-item">
                  <img className='achivement-img' src={achievement_img1} alt="forbes logo" loading='lazy' style={{marginBottom:'7.5rem'}} />
                  <p className="font-secondary" style={{fontWeight:'200'}}>The Forbes Coaches Council is an esteemed community of leading coaches and experts who share their insights and strategies to help businesses thrive. Dr. Gamini Hewawasam is a valued member of this council, where he contributes to Forbes Expert Panels and authors articles on leadership and mindfulness. His work emphasizes the transformative power of mindfulness in leadership, guiding professionals to enhance their decision-making and foster a culture of introspection and resilience.</p>
                </div>
              </div>
              <div className="col-lg-6 d-flex">
                <div className="achivement-item achivement-item-right">
                  <img className='achivement-img a2' src={achievement_img2} alt="harvard business review logo" loading='lazy' style={{height: '180px'}}/>
                  <p className="font-secondary" style={{fontWeight:'200'}}>As an advisory council member at Harvard Business Review, Dr. Gamini Hewawasam provides valuable insights into the intersection of leadership and mindfulness. His contributions help guide the publication's exploration of effective management strategies, emphasizing the transformative potential of mindfulness in enhancing decision-making and cultivating a resilient organizational culture.</p>
                </div>
              </div>
            </div></div>
          </div>
        </section> */}

        <section
          id="our-missionVision"
          className="our-missionVision why-choose-item"
        >
          <div
            id="our-missionVision-content"
            className="our-missionVision-content d-flex col-md-12"
          >
            {/* Our Vision */}
            <div className="col-md-4 d-flex vm-card-col">
              <div className="vm-container text-center">
                <h3 className="font-primary">Our Vision</h3>
                <div className="col-md-12 d-flex flex-column align-items-center">
                  <img
                    className="vm-icon"
                    src={vision_icon}
                    alt="vision icon"
                    loading="lazy"
                  />
                  <p className="font-secondary mt-3">
                    To unlock leadership potential with mindfulness vacations.
                  </p>
                </div>
              </div>
            </div>

            {/* Our Mission */}
            <div
              className="col-md-4 d-flex vm-card-col"
              style={{ justifyContent: "center" }}
            >
              <div className="vm-container vm-container-middle text-center">
                <h3 className="font-primary">Our Mission</h3>
                <div className="col-md-12 d-flex flex-column align-items-center">
                  <img
                    className="vm-icon"
                    src={mission_icon}
                    alt="mission icon"
                    loading="lazy"
                  />
                  <p className="font-secondary mt-3">
                    To uncover the hidden gem of authentic Buddhist teachings
                  </p>
                </div>
              </div>
            </div>

            {/* Our Values */}
            <div
              className="col-md-4 d-flex vm-card-col"
              style={{ justifyContent: "right" }}
            >
              <div className="vm-container vmc3 text-center">
                <h3 className="font-primary">Our Values</h3>
                <div className="col-md-12 d-flex flex-column align-items-center">
                  <img
                    className="vm-icon"
                    src={goal_icon}
                    alt="values icon"
                    loading="lazy"
                  />
                  <ul className="values-li mt-3 text-left">
                    <li className="font-secondary">Introspection</li>
                    <li className="font-secondary">Compassionate Leadership</li>
                    <li className="font-secondary">Holistic Well-being</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default AboutUsContent;
